<template>
  <div id="app">
    <!-- <button v-on:click="logout" v-if="$store.state.tokenId">Log out</button> -->
    <button v-on:click="login" v-if="!$store.state.tokenId">Log in</button>
    <div v-if="$store.state.initialized">
      <div id="nav">
        <router-link to="/users"
          >Users
          <!-- <router-link
            to="/users/audit"
            style="position:absolute;top:0;right:0;background-color:gray"
            >Audit</router-link
          > -->
        </router-link>
        <router-link to="/companies">Companies
          <!-- <router-link
            to="/companies/audit"
            style="position:absolute;top:0;right:0;background-color:gray"
            >Audit</router-link> -->
        </router-link>
        <router-link to="/orders"
          >Orders
          <!-- <router-link
            to="/orders/audit"
            style="position:absolute;top:0;right:0;background-color:gray"
            >Audit
          </router-link> -->
        </router-link>
        <router-link to="/carts">Carts
        </router-link>
        <router-link to="/skills">Skills
        </router-link>
        <router-link
          to="/call"
          style="position:absolute;top:0;right:0;background-color:gray"
        >Call</router-link>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import api from "./services/api";
import msal from "./services/msal";

export default {
  name: "app",
  updated: async function() {
    console.log('updated');
    if (this.$route.name === 'call') {
      // console.log('skipping services init');
      this.$store.commit("setInitialized", true);
    } else if (this.$store.state.tokenId && !this.$store.state.skills) {
      this.$store.commit("setInitialized", false);
      Promise.all([
        // api.getUsers(),
        api.getServices(),
        api.getPlatformConfig()
      ]).then(([services, config]) => {
        // console.log("initialized");
        this.$store.commit("setServices", services);
        this.$store.commit("setConfig", config);
        console.log(config);
        this.$store.commit("setInitialized", true);
      });
    }
    //const skills = await api.getSkills();
  },
  methods: {
    login: () => {
      msal.signIn();
    },
    logout: () => {
      msal.signOut();
    }
  }
};
</script>

<style lang="less" src="./App.less"></style>
<style lang="less" src="./DataTable.less"></style>
